var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#515864",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.183 20.235h-9.77L21.75 8.498a.905.905 0 000-1.248L16.93 2.258a.832.832 0 00-1.205 0L3.67 14.738a.904.904 0 000 1.247l4.105 4.25H2V22h18.183v-1.765zm-7.196-5.16L9.37 11.331l-3.892 4.03 3.616 3.744 3.893-4.03z"
  })));
}
export default SvgEraser;